import { render, staticRenderFns } from "./StockReportMainTable.vue?vue&type=template&id=4cdd38c3"
import script from "./StockReportMainTable.vue?vue&type=script&lang=js"
export * from "./StockReportMainTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports